import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../shared/Inputs/TextInput/TextInput'
import SelectInput from '../../../shared/Inputs/SelectInput/SelectInput'
import FileInput from '../../../shared/Inputs/FileInput/FileInput'
import DatePicker from '../../../shared/Inputs/DatePicker/DatePicker'
import { yearsAgo, parseDate } from '../../../utils/helpers'
import {
  validateString,
  validateDate,
  smartValidateString,
} from '../../../validate/validators'
import { Lang } from '../../../types/common-types'
import { COUNTRY, UPLOADS_ENDPOINT } from '../../../server-parameters'
import styles from '../ScreenOne.module.scss'
import { State } from '../../../state-actions-reducers'
import { L10n } from '../../../types/common-types'
import InfoMessage from '../../../shared/InfoMessage/InfoMessage'
import CheckBoxInput from '../../../shared/Inputs/CheckBoxInput/CheckBoxInput'

interface Props {
  lang: Lang
  accountForm: any
  selectedCitizenship?: string
  documentsTypeValues: {
    value: string | number
    label: L10n
  }[]
}

export default function AdditionalDocuments({
  lang,
  accountForm,
  selectedCitizenship,
  documentsTypeValues,
}: Props) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()

  const MILITARY_ID = '6'
  const MILITARY_REGISTRATION_CERTIFICATE = '13'
  const isExclusivePair = (a: string, b: string) =>
    (a === MILITARY_ID && b === MILITARY_REGISTRATION_CERTIFICATE) ||
    (a === MILITARY_REGISTRATION_CERTIFICATE && b === MILITARY_ID)

  const birthDate = state.birthDate && parseDate(state.birthDate)
  const isOlderThan30 = !!birthDate && birthDate < yearsAgo(30)

  const availableDocumentsTypeValues = documentsTypeValues?.filter(
    item => !(isOlderThan30 && String(item.value) === MILITARY_REGISTRATION_CERTIFICATE)
  )

  const [documentTypeOptions, setDocumentTypeOptions] = useState(
    availableDocumentsTypeValues?.filter(e => {
      if (
        state.passportType !== String(e?.value) &&
        !(+state.passportType === 4 && +e?.value === 11)
      )
        return {
          label: e.label,
          value: e.value,
        }
    })
  )
  const [secondDocumentTypeOptions, setSecondDocumentTypeOptions] = useState(
    availableDocumentsTypeValues?.filter(e => {
      if (
        state.passportType !== String(e.value) &&
        !(+state.passportType === 4 && +e?.value === 11)
      )
        return {
          label: e.label,
          value: e.value,
        }
    })
  )
  useEffect(() => {
    setSecondDocumentTypeOptions(
      availableDocumentsTypeValues?.filter((item: any) => {
        if (
          state.additionalDocumentType !== String(item.value) &&
          state.passportType !== String(item.value) &&
          !(+state.passportType === 4 && +item?.value === 11) &&
          !isExclusivePair(state.additionalDocumentType, String(item.value))
        )
          return item
      })
    )
    setDocumentTypeOptions(
      availableDocumentsTypeValues?.filter((item: any) => {
        if (
          state.secondAdditionalDocumentType !== String(item.value) &&
          state.passportType !== String(item.value) &&
          !(+state.passportType === 4 && +item?.value === 11) &&
          !isExclusivePair(state.secondAdditionalDocumentType, String(item.value))
        )
          return item
      })
    )
  }, [
    state.additionalDocumentType,
    state.secondAdditionalDocumentType,
    selectedCitizenship,
    state.passportType,
    documentsTypeValues,
    isOlderThan30,
  ])

  useEffect(() => {
    const documentTwo = availableDocumentsTypeValues?.filter((item: any) => {
      if (
        state.additionalDocumentType !== String(item.value) &&
        state.passportType !== String(item.value) &&
        !(+state.passportType === 4 && +item?.value === 12)
      )
        return item
    })
    const documentOne = availableDocumentsTypeValues?.filter((item: any) => {
      if (
        state.secondAdditionalDocumentType !== String(item.value) &&
        state.passportType !== String(item.value) &&
        !(+state.passportType === 4 && +item?.value === 12)
      )
        return item
    })
    console.log(
      'test state.additionalDocumentType',
      state.passportType,
      state.additionalDocumentType
    )
    if (
      (!documentOne.find(e => String(e.value) === state.additionalDocumentType) &&
        state.additionalDocumentType) ||
      state.passportType === state.additionalDocumentType
    ) {
      setValue('additionalDocumentType', String(documentOne?.[0]?.value ?? ''), { shouldDirty: true })
    }
  }, [documentsTypeValues, state.passportType, isOlderThan30])

  return (
    <div className="form-group">
      <div className="row">
        <div className="col-12 col-xs-12">
          <h3>{accountForm.stepOneAdditional[lang]}</h3>
        </div>
        <div className="col-4 col-xs-12">
          <SelectInput
            testName={'additionalDocumentType'}
            testErrorName={'error-additionalDocumentType'}
            lang={lang}
            noOptionsMessage={accountForm.additionalDocumentType.placeholder}
            content={accountForm.additionalDocumentType}
            value={state.additionalDocumentType}
            options={documentTypeOptions}
            onChange={data => {
              setValue('additionalDocumentType', data, { shouldDirty: true })
              setValue('isAdditionalDocumentPerpetual', false, { shouldDirty: true })
            }}
            valid={
              !errors.additionalDocumentType &&
              validateString(state.additionalDocumentType, 50)
            }
            className={styles.input}
          />
        </div>
        {state.additionalDocumentType !== '6' &&
          state.additionalDocumentType !== '10' &&
          state.additionalDocumentType !== MILITARY_REGISTRATION_CERTIFICATE &&
          !(state.additionalDocumentType === '1' && state.citizenship === '643') ? (
          <div className="col-2 col-xs-12">
            {/* ADDITIONAL DOCUMENT EXPIRY DATE */}
            <DatePicker
              testName="additionalDocumentDateExpiry"
              testErrorName="error-additionalDocumentDateExpiry"
              disabled={!state.agreed || state.isAdditionalDocumentPerpetual}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="countryResidencePermitDate"
              onChange={data =>
                setValue('additionalDocumentDateExpiry', data, { shouldDirty: true })
              }
              value={state.additionalDocumentDateExpiry}
              required
              valid={
                !errors.additionalDocumentDateExpiry &&
                validateDate({
                  current: state.additionalDocumentDateExpiry,
                  min: new Date(),
                  max: new Date(
                    new Date().setFullYear(new Date().getFullYear() + 10)
                  ),
                })
              }
              min={new Date()}
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() + 10))
              }
              checkLabel={state.additionalDocumentType === '12' && accountForm.isAdditionalDocumentPerpetual[lang]}
              checkValue={state.additionalDocumentType === '12' && state.isAdditionalDocumentPerpetual}
              checkChange={() => {
                state.additionalDocumentType === '12' && setValue('isAdditionalDocumentPerpetual', !state.isAdditionalDocumentPerpetual, { shouldDirty: true })
              }}
            />
          </div>
        ) : null}
        <div className="col-4 col-xs-12">
          <FileInput
            testName="documentsPhotoOne"
            testErrorName="error-documentsPhotoOne"
            disabled={!state.agreed}
            lang={lang}
            url={UPLOADS_ENDPOINT}
            autorization={state.formId}
            target={state.documentsImages}
            documentType="additionalDocument"
            content={accountForm.documentsPhoto}
            
            onChange={documentsPhotoOne => {
              setValue('documentsPhotoOne', [...getValues('documentsPhotoOne'), documentsPhotoOne], { shouldDirty: true })
            }}
            valid={!errors.documentsPhotoOne}
            value={state.documentsPhotoOne[state.documentsPhotoOne.length - 1]}
            imageErrors={state.imageError}
          />
        </div>
        <div className="col-4 col-xs-12">
          <TextInput
            testName="additionalDocumentComment"
            testErrorName="error-additionalDocumentComment"
            disabled={!state.agreed}
            lang={lang}
            content={
              state.additionalDocumentType === '12'
                ? accountForm.countryResidencePermitNumber
                : state.additionalDocumentType === '3'
                  ? accountForm.passportInternationalNumberRus
                  : accountForm.comments
            }
            onChange={comments =>
              setValue('additionalDocumentComment', comments, { shouldDirty: true })
            }
            value={state.additionalDocumentComment || ''}
            mask={state.additionalDocumentType === '3' ? '99 9999999' : undefined}
            valid={
              state.additionalDocumentType === '12' || state.additionalDocumentType === '3' ?
                !errors.additionalDocumentComment
                : true
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-4 col-xs-12">
          <SelectInput
            testName={'secondAdditionalDocumentType'}
            testErrorName={'error-secondAdditionalDocumentType'}
            lang={lang}
            noOptionsMessage={
              COUNTRY === 'kz' ? accountForm.secondAdditionalDocumentType.placeholder : accountForm.secondAdditionalDocumentTypeNotRequired.placeholder
            }
            content={COUNTRY === 'kz' ? accountForm.secondAdditionalDocumentType : accountForm.secondAdditionalDocumentTypeNotRequired}
            value={state.secondAdditionalDocumentType}
            options={[{
              value: '0',
              label: {
                eng: 'Not selected',
                rus: 'Не выбрано',
                kz: 'Таңдалмаған',
              },
            }, ...secondDocumentTypeOptions]}
            onChange={data =>
              setValue('secondAdditionalDocumentType', data, { shouldDirty: true })
            }
            className={styles.input}
            valid={
              !errors.secondAdditionalDocumentType
            }
          />
        </div>
        {state.secondAdditionalDocumentType !== '0' &&
          state.secondAdditionalDocumentType !== '6' &&
          state.secondAdditionalDocumentType !== '10' &&
          state.secondAdditionalDocumentType !== MILITARY_REGISTRATION_CERTIFICATE &&
          !(state.secondAdditionalDocumentType === '1' && state.citizenship === '643') ? (
          <div className="col-2 col-xs-12">
            {/* ADDITIONAL DOCUMENT EXPIRY DATE */}
            <DatePicker
              testName="secondAdditionalDocumentDateExpiry"
              testErrorName="error-secondAdditionalDocumentDateExpiry"
              disabled={!state.agreed || state.isSecondAdditionalDocumentPerpetual}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="countryResidencePermitDate"
              onChange={data => {
                setValue('secondAdditionalDocumentDateExpiry', data, { shouldDirty: true })
                setValue('isSecondAdditionalDocumentPerpetual', false, { shouldDirty: true })
              }}
              value={state.secondAdditionalDocumentDateExpiry}
              required
              valid={
                !errors.secondAdditionalDocumentDateExpiry &&
                validateDate({
                  current: state.secondAdditionalDocumentDateExpiry,
                  min: new Date(),
                  max: new Date(
                    new Date().setFullYear(new Date().getFullYear() + 10)
                  ),
                })
              }
              min={new Date()}
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() + 10))
              }
              checkLabel={state.secondAdditionalDocumentType === '12' && accountForm.isAdditionalDocumentPerpetual[lang]}
              checkValue={state.secondAdditionalDocumentType === '12' && state.isSecondAdditionalDocumentPerpetual}
              checkChange={() => {
                state.secondAdditionalDocumentType === '12' && setValue('isSecondAdditionalDocumentPerpetual', !state.isSecondAdditionalDocumentPerpetual, { shouldDirty: true })
              }}
            />
          </div>
        ) : null}
        {+state.secondAdditionalDocumentType > 0 &&
          <div className="col-4 col-xs-12">
            <FileInput
              testName="documentsPhotoTwo"
              testErrorName="error-documentsPhotoTwo"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.documentsPhoto}
              documentType="secondDocument"
              
              onChange={documentsPhotoTwo => {
                setValue('documentsPhotoTwo', [...getValues('documentsPhotoTwo'), documentsPhotoTwo], { shouldDirty: true })
              }}
              value={state.documentsPhotoTwo[state.documentsPhotoTwo.length - 1]}
              valid={!errors.documentsPhotoTwo}
              imageErrors={state.imageError}
            />
          </div>
        }
        {+state.secondAdditionalDocumentType > 0 &&
          <div className="col-4 col-xs-12">
            <TextInput
              testName="secondAdditionalDocumentComment"
              testErrorName="error-secondAdditionalDocumentComment"
              disabled={!state.agreed}
              lang={lang}
              content={
                state.secondAdditionalDocumentType === '12'
                  ? accountForm.countryResidencePermitNumber
                  : state.secondAdditionalDocumentType === '3'
                    ? accountForm.passportInternationalNumberRus
                    : accountForm.comments
              }
              onChange={comments =>
                setValue('secondAdditionalDocumentComment', comments, { shouldDirty: true })
              }
              value={state.secondAdditionalDocumentComment || ''}
              mask={state.secondAdditionalDocumentType === '3' ? '99 9999999' : undefined}
              valid={
                state.secondAdditionalDocumentType === '12' || state.secondAdditionalDocumentType === '3' ?
                  !errors.secondAdditionalDocumentComment
                  : true
              }
            />
          </div>
        }
        <div className="col-12">
          <InfoMessage text={lang === 'eng' ? "The additional document is not mandatory for completion but we strictly advice to fullfill it as far as this information will significantly influence to the collateral conditions. Please upload the exact document you have selected. Do not upload copy of main document or fakes." :
            lang === 'kz' ? "Қосымша құжатты толтыру міндетті емес, бірақ ол кепілдікті анықтауға айтарлықтай әсер етеді, сондықтан оны толтыруды ұсынамыз. Сіз таңдаған нақты құжатты жүктеп салыңыз. Негізгі құжаттың көшірмесін немесе жалғанды ​​жүктеп салмаңыз." :
              "Дополнительный документ не является обязательным для заполнения, однако он существенно повлияет на определение залога, поэтому советуем его заполнить. Пожалуйста, не нужно загружать документы, которых нет, или основной документ повторно! Загружайте только те документы, которые указываете!"} />
        </div>
      </div>
    </div>
  )
}
